import { Formik } from "formik";
import React, { useState } from "react";
import Loader from "../components/Loader";
import { useNavigate } from "react-router";
import WaterRipple from "../layout/RippleEffect";
import { pageRoutes } from "../routes/PageRoutes";
import { ForgotPasswordSchema } from "../auth/Schema";
import ErrorMessage from "../components/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { userForgotPassword } from "../redux/actions/authActions";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.authReducer);

  const initialState = {
    email: "",
  };

  const onHandleForgotPassword = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes.login);
      }
    };
    dispatch(userForgotPassword({ payload: values, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      {/* <section className="ct_login_main_div">
            <div className="container-fluid px-0">
                <div className="ct_login_left_bg">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-md-0">
                        </div>
                        <div className="col-lg-4 offset-0 offset-lg-1  mb-4 mb-lg-0">
                            <div className="ct_login_right_form w-60 mx-auto mx-lg-0">
                                <div className="ct_login_logo mx-auto d-block text-center mb-4">
                                    <img src="img/blue_logo_new.png" alt="" />
                                </div>
                                <div className="mb-5 text-center">
                                    <h4 className="ct_fs_28 mb-2">Forgot Password</h4>
                                </div>
                                <Formik
                                    initialValues={initialState}
                                    validationSchema={ForgotPasswordSchema}
                                    onSubmit={(values, actions) => {
                                        onHandleForgotPassword(values, actions);
                                    }}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                    }) => (
                                        <form>
                                            <div className="ct_input-group mb-4">
                                                <label className="mb-2 ct_fw_700">Email <span className="ct_required_star">*</span></label>
                                                <input
                                                    id="email"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values?.email}
                                                    type="email"
                                                    autocomplete="off"
                                                    className="ct_input"
                                                    required
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName="email"
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <button type="submit" onClick={handleSubmit} className="ct_custom_btm">
                                                    <span className="circle1"></span>
                                                    <span className="circle2"></span>
                                                    <span className="circle3"></span>
                                                    <span className="circle4"></span>
                                                    <span className="circle5"></span>
                                                    <span className="text">Get reset link</span>
                                                </button>
                                            </div>
                                            <p className="mb-0 mt-3 ct_login_btm">Already know your password? <a onClick={() => navigate(pageRoutes.login)}
                                                href="javascript:void(0)">Login</a></p>

                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}

      {/* forgot new */}

      <section className="et_signup_main_bg">
        <div className="ct_header_flex">
          <div className="et_logo">
            <a
              href="javascript:void(0)"
              onClick={() => {
                navigate(pageRoutes?.landingpage);
              }}
            >
              {" "}
              <img src="img/Logo_blue_new.png" />
            </a>
          </div>
        </div>

        {/* forgot content */}
        <div className="auth-wrapper">
          <WaterRipple />
          <div className="container-fluid">
            <div className="ct-login-wrapper">
              <div className="ct-login-card ct_custom_scroll">
                <div className="text-center ct_mb_32">
                  <div className="ct-title ct_fs_24 ct_idlewild_bold mb-2 ct_blue_text ct_fs_20_575">
                    Forgot Password
                  </div>
                  <div className="ct-subtitle ct_blue_text ct_ff_ProximaNova_regular mb-0 ct_fs_14 ct_fw_400">
                    Don’t worry it happens, please enter the email associated
                    with your account.
                  </div>
                </div>

                <Formik
                  initialValues={initialState}
                  validationSchema={ForgotPasswordSchema}
                  onSubmit={(values, actions) => {
                    onHandleForgotPassword(values, actions);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  }) => (
                    <form>
                      <div className="ct_input-group mb-4">
                        <label className="mb-2 ct_fw_700">
                          Email <span className="ct_required_star">*</span>
                        </label>
                        <input
                          id="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.email}
                          type="email"
                          autocomplete="off"
                          class="form-control ct_input ct_border_radius_8"
                          required
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName="email"
                        />
                      </div>
                      <div className="mt-4">
                        {/* <button type="submit" onClick={handleSubmit} className="ct_custom_btm">
                                                    <span className="circle1"></span>
                                                    <span className="circle2"></span>
                                                    <span className="circle3"></span>
                                                    <span className="circle4"></span>
                                                    <span className="circle5"></span>
                                                    <span className="text">Get reset link</span>
                                                </button> */}

                        <button
                          onClick={handleSubmit}
                          type="submit"
                          class="ct_orange_btn w-100"
                        >
                          Get reset link
                        </button>
                      </div>

                      <div class="ct_login_divider mt-3"></div>

                      <div class="ct_mt_25 text-center ct_text_dark ct_fs_14 ct-fw_400">
                        Already Know Your Password?
                        <a
                          onClick={() => navigate(pageRoutes.login)}
                          href="javascript:void(0)"
                          class="ct_blue_text ct_fs_14 ct_fw_600 ms-2"
                        >
                          Log In
                        </a>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>

        {/* forgot content end */}
      </section>
    </>
  );
};

export default ForgotPassword;
